<template>
  <v-row>
    <v-col cols="12">
      <v-card class="mt-2 mb-2">
        <v-app-bar flat color="rgba(0, 0, 0, 0)">
          <v-toolbar-title class="text-h8"> Maintenance mode </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-app-bar>
        <v-card-text>
          <v-row>
            <v-col cols="6" class="pt-2 pb-2">
              <p>Status:</p>
            </v-col>
            <v-col cols="6" class="pt-2 pb-2">
              <p :class="maintenanceMode ? 'red--text' : 'blue--text'">
                {{ maintenanceMode }}
              </p>
            </v-col>
            <v-col cols="6" class="pt-2 pb-2">
              <p>Server started:</p>
            </v-col>
            <v-col cols="6" class="pt-2 pb-2">
              <p>
                {{ $utils.relativeTimeFromTs(serverStartedTs) }}
              </p>
            </v-col>
            <v-col cols="0" md="5"></v-col>
            <v-col cols="12" md="3" class="pt-2 pb-2">
              <v-btn
                :color="maintenanceMode ? 'orange' : 'red'"
                class="white--text"
                :loading="maintenanceModeBtnLoading"
                @click="changeMaintenanceMode()"
              >
                {{ maintenanceMode ? "Disable" : "Enable" }}
                maintenance mode
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    maintenanceMode: {
      type: Boolean,
      default: false,
    },
    serverStartedTs: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      maintenanceModeBtnLoading: false,
    };
  },
  methods: {
    changeMaintenanceMode() {
      // disable maintenance mode
      this.maintenanceModeBtnLoading = true;
      var desiredMode = !this.maintenanceMode;
      var promptText = "";
      if (desiredMode) {
        promptText =
          "Are you sure you want to ENABLE maintenance mode? This would block all the users from the website.";
      } else {
        promptText =
          "Are you sure you want to DISABLE maintenance mode? This would allow all the users to access the website.";
      }
      if (!confirm(promptText)) {
        this.maintenanceModeBtnLoading = false;
        return;
      }
      this.$http
        .post(
          this.$consts.BE_ADDRESS + "/admin/setMaintenanceMode",
          {
            maintenanceMode: desiredMode,
          },
          {
            headers: {
              Authorization: this.$store.state.token,
            },
          },
        )
        .then((response) => {
          if (response.status === 200) {
            this.$emit("update:maintenance-mode", desiredMode);
            return;
          }
          this.$utils.handleKnownRespCodes(this, response.status);
        })
        .catch((error) => {
          this.$utils.handleBackendError(this, error);
        })
        .finally(() => {
          this.maintenanceModeBtnLoading = false;
        });
    },
  },
};
</script>
